<template>
    <div class="sponsorContainer" align="center">
        <span>Mit freundlicher Unterstützung von:</span>
        <img v-bind:class="imageVisible ? '' : 'hidden'"
             v-bind:src="'https://cdn.gemeindeplaner.at/pv-wimsbach/' + currentSponsor()"/>
    </div>
</template>

<script>
    export default {
        name: 'SponsorSwitcher',
        components: {},
        props: {
            switchTime: {
                type: Number,
                default: 5000,
            },
        },
        data: () => {
            return {
                imageVisible: true,
                currentIndex: 0,
                sponsors: [
                    'upperaustria.png',
                    'klimarettung.jpeg',
                    'huemer_solar.png',
                    'fronius.png',
                    'bad_wimsbach.png',
                ],
            };
        },
        methods: {
            nextSponsor () {
                this.imageVisible = false;
                setTimeout(() => {
                    this.currentIndex++;

                    if (this.currentIndex >= this.sponsors.length) {
                        this.currentIndex = 0;
                    }
                    this.imageVisible = true;
                }, 500);

            },
            currentSponsor () {
                return this.sponsors[this.currentIndex];
            },
        },
        mounted () {
            setInterval(this.nextSponsor, this.switchTime);
        },
    };
</script>

<style scoped>
    .sponsorContainer img {
        max-width: 300px;
        width: 100%;
        opacity: 1;
        transition: opacity .5s;
    }

    .sponsorContainer img.hidden {
        opacity: 0;
    }
</style>
